var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tipped-text',{attrs:{"tip":_vm.fullText}},[_vm._v(_vm._s(_vm.abbrevText))])
}
var staticRenderFns = []

export { render, staticRenderFns }